<template>
  <div class="content">
    <div class="container">
      <div class="holder holder-image">
        <div id="js-imageBuildeContainer" class ref="canvasWrapper">
          <div id="span-order-numder" class="order-numder">
            <span style>{{ $t("front_end.a110.label.order_no") }}:{{ orderNo }}</span>
          </div>
        </div>
        <div class="mt-4 image-box" v-if="postcardInfomation.imageURL">
          <div class="image-box-title">{{ $t("front_end.a110.label.image_header") }}</div>
          <div class="image"><img :src="postcardInfomation.imageURL" alt /></div>
          <div class="image-box-title">{{ $t("front_end.a110.label.image_footer") }}</div>
        </div>
      </div>
      <div class="content-footer-detail-design container" id="content-footer-detail">
        <button
          class="col-md-4 col-lg-2 col-4 btn-editor-submit btn-editor"
          @click="reorderEntry()"
        >{{$t('front_end.a110.reorder_btn')}}</button>
      </div>
    </div>
  </div>
</template>
<script>
import api from "@/services/api";
import apiEndpoints from "@/services/apiEndpoints";
import { mapGetters, mapState } from "vuex";
import ConvertImage from "@/helpers/base64toimg";

export default {
  name: "A110",
  data() {
    return {
      postcardInfomation: {
        imageURL: ""
      },
      isLoading: false,
      orderNo: "",
      definision: "",
      category: "",
      orderToken: ""
    }
  },
  created() {
    this.showOrderImage();
  },
  computed: {
    ...mapGetters(["shopMode"]),
    ...mapState({
      orderInfo: state => state.userData.order
    }),
    reOrderData() {
      return {
        orderNo: this.$route.params.orderNo
      }
    }
  },
  methods: {
    showOrderImage() {
      let self = this;
      let params = this.reOrderData;
      if(this.isLoading) {
        return "";
      }
      this.isLoading = true;

      api.post(apiEndpoints.showOrderImage, params)
        .then(({data}) => {
          self.clearSessionReOrder();
          self.isLoading = false;
          self.postcardInfomation.imageURL = ConvertImage.convert(data.imageData)
          this.orderNo = data.orderNo;
          this.$store.commit("userData/SET_ORDER", {
            reOrder: this.orderNo,
            orderToken: this.reOrderData.orderNo
          })
          this.definision = data.definision ?? ""
          this.category = data.category ?? ""
          this.$store.commit("userData/SET_SELECTED", {
            definision: this.definision,
            category: this.category
          });
        }).catch((err) => {
          self.isLoading = false;
          console.log(err);
        });
    },
    reorderEntry() {
      let self = this;
      if(this.isLoading) {
        return "";
      }

      let params = {
        shopId: this.shopMode.shopId,
        orderNo: this.reOrderData.orderNo
      };
      this.isLoading = true;
      api.post(apiEndpoints.reorderEntry, params)
        .then(({data}) => {

          self.isLoading = false;
          if (data) {
            self.saveNewOrderNo(data.newOrderNo);
            self.$router.push({ name: "a030" });
          }
        }).catch((err) => {
          self.isLoading = false;
          console.log(err);
        });
    },
    saveNewOrderNo(newOrderNo) {
      let orderInfo = this.orderInfo;
      orderInfo.orderNo = newOrderNo;
      this.$store.commit("userData/SET_ORDER", orderInfo)
    },
    clearSessionReOrder() {
      this.$store.dispatch("userData/clearSession");
      this.$store.dispatch("userData/clearSessionReOrder");
    }
  }
}
</script>

<style scoped src="../../assets/css/detailDesign/detailDesign.css"></style>
<style scoped src="../../assets/css/editor/editor.css"></style>

<style scoped>
.holder-image {
  width: 60%;
}
.image-box {
  border: 1px solid;
  border-color: gray;
  background: gray;
}
.image-box img {
  width: 100%;
}
.image-box-title {
  text-align: center;
  color: white;
  /* padding: 5px; */
}

.btn-editor-submit {
  /* font-size: 1.2rem; */
  padding: 5px;
}
@media screen and (min-width: 1024px) {
  .holder-image {
    width: 60%;
  }
  .image-box .image {
    padding-left: 20px;
    padding-right: 20px;
  }
}
@media screen and (max-width: 768px) {
  .image-box .image {
    padding-left: 15px;
    padding-right: 15px;
  }
  .image-box-title {
    font-size: 15px;
  }
  .holder-image {
    width: 80%;
  }
}
@media screen and (max-width: 480px) { 
  .image-box-title {
    font-size: 10px;
  }
  .image-box .image {
    padding-left: 15px;
    padding-right: 15px;
  }
}
</style>
